var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeRoot",attrs:{"id":"home-root"}},[(_vm.isMobile())?_c('mobile-home'):_c('web-home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }